import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateHeadingFontSize = ({
  fontSize,
  mobileFontSize,
}: {
  fontSize?: number
  mobileFontSize?: number
}) => {
  const {
    fontSize: websiteGlobalFontSize,
    mobileFontSize: websiteGlobalMobileFontSize,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const pageGlobalFontSize = usePage(pageSelectors.getGlobalTextFontSize)

  const pageGlobalMobileFontSize = usePage(
    pageSelectors.getGlobalMobileTextFontSize,
  )

  const globalFontSize = pageGlobalFontSize || websiteGlobalFontSize
  const globalMobileFontSize =
    pageGlobalMobileFontSize || websiteGlobalMobileFontSize
  return {
    calculatedFontSize: getCalculatedProperty({
      desktopProperty: fontSize,
      mobileProperty: mobileFontSize,
      globalDesktopProperty: globalFontSize,
      globalMobileProperty: globalMobileFontSize,
    }),
  }
}
